// 缓存配置文件  如果有需要配置缓存页面，将页面name配置在此array中即可
export  const keepAliveList = ['会议管理','投屏管理']
// 不需要缓存的配置页面
export const noKeepAliveList = ['/bigData/userGraph/detail', '/apps/pageStrategy/index']